'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FilePickerRuntimeContext } from '#pplx/frontend/composer-sdk/internal/file-picker/FilePickerContext.js';
import { useCallback, useMemo, useRef } from 'react';
/** Mounts persistent native file inputs and exposes their plugin-scoped open handles. */
export function FilePickerCapabilityHost({ children, plugins, disabled = false, }) {
    const inputRefs = useRef(new Map());
    const pickerPlugins = useMemo(() => plugins.filter((plugin) => plugin.filePicker !== undefined), [plugins]);
    const registry = useMemo(() => new Map(pickerPlugins.map((plugin) => [
        plugin.id,
        {
            open: () => {
                const input = inputRefs.current.get(plugin.id);
                if (input?.disabled === false) {
                    input.click();
                }
            },
        },
    ])), [pickerPlugins]);
    const setInputRef = useCallback((pluginId, input) => {
        if (input === null) {
            inputRefs.current.delete(pluginId);
            return;
        }
        inputRefs.current.set(pluginId, input);
    }, []);
    return (_jsxs(FilePickerRuntimeContext.Provider, { value: registry, children: [children, pickerPlugins.map((plugin) => {
                const configure = plugin.filePicker;
                if (configure === undefined) {
                    return null;
                }
                // Static plugins created with createPlugin() have no live props; factories provide them.
                const config = configure(plugin.props ?? {});
                const handleChange = (event) => {
                    const files = event.currentTarget.files;
                    if (!disabled && config.disabled !== true && files !== null && files.length > 0) {
                        config.onSelect(Array.from(files));
                    }
                    // The native input must be reset so choosing the same file again emits change.
                    event.currentTarget.value = '';
                };
                return (_jsx("input", { ref: (input) => setInputRef(plugin.id, input), type: "file", accept: config.accept?.join(','), multiple: config.multiple, disabled: disabled || config.disabled === true, hidden: true, tabIndex: -1, onChange: handleChange }, plugin.id));
            })] }));
}
//# sourceMappingURL=FilePickerCapabilityHost.js.map